import React from 'react';
import { Avatar, PinAll, Tooltip } from '@marvelapp/ui';
export const Player = React.memo(({ name, avatarUrl, activeColor = 'purple', avatarSize = 32, tooltipPosition = 'bottom', }) => {
    const activeCircleBorderSize = 2;
    return (React.createElement(Tooltip, { content: name, cursor: "default", display: "block", position: tooltipPosition },
        React.createElement(Avatar, { alt: name, size: avatarSize, src: avatarUrl }),
        React.createElement(PinAll, { border: `${activeCircleBorderSize}px solid`, borderColor: "currentColor", borderRadius: avatarSize / 2, boxShadow: `0 0 0 ${activeCircleBorderSize}px white`, color: activeColor, height: avatarSize, width: avatarSize })));
});
